import React from 'react';
import PropTypes from 'prop-types';

import { FontSize, FontWeight } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import { IClassNames, makeClassNames } from '../../../utils/styles';
import Text, { TextTags } from '../../atoms/text/text';
import t from '../../../labels/labelling-utils';

import './data-source.scss';

export interface IDataSource extends IComponent {
  dataSource: string;
}

const DATA_SOURCE_TAG: TextTags = 'p';

const DATA_SOURCE_FONT_SIZE: FontSize = '12';
const DATA_SOURCE_FONT_WEIGHT: FontWeight = '400';

const classNames = (): IClassNames =>
  makeClassNames({
    dataSourceWrapper: 'data-source--wrapper',
    dataSource: 'data-source',
    dataSourceString: 'data-source-string',
  });

const DataSource: React.FC<IDataSource> = ({ dataSource = '' }) => {
  const cn = classNames();

  return (
    <div className={cn.dataSourceWrapper}>
      <Text
        className={cn.dataSource}
        fontSize={DATA_SOURCE_FONT_SIZE}
        fontWeight={DATA_SOURCE_FONT_WEIGHT}
        tag={DATA_SOURCE_TAG}
      >
        <span>{t('dataSource.data.source')}:</span> <span className={cn.dataSourceString}>{dataSource}</span>
      </Text>
    </div>
  );
};

DataSource.propTypes = {
  dataSource: PropTypes.string.isRequired,
};

export default DataSource;
